import styled from 'styled-components';
import background from '../images/background-isotipo.png.png';
import DefaultContainer from './DefaultContainer';

export default styled(DefaultContainer)`
  min-height: 100vh;
  background-size: 700px;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-position: calc(100% + 300px);

  > .center {
    padding: 120px 3% 60px 3%;
    gap: 32px;

    @media ${({ theme }) => theme.devices.mobile} {
      padding: 130px 3% 60px 3%;
    }
  }

  > .alignCenter {
    margin-top: 15%;
    padding: 0px 3% 60px 3%;
    gap: 32px;
  }
`;
